import { Decimal } from "decimal.js-light";

Decimal.set({
  toExpPos: 9e24,
  toExpNeg: -9e24,
  rounding: Decimal.ROUND_DOWN,
  precision: 64,
});

export { Decimal };
